import React, { Fragment } from 'react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { MoreHorizontal } from 'lucide-react';

export const PSPActionsMenu = ({ proposalId, actions = [] }) => (
  <DropdownMenu modal={false}>
    <DropdownMenuTrigger asChild>
      <button
        type="button"
        onClick={(e) => e.stopPropagation()}
        className="p-1.5 rounded-md text-slate-500 hover:text-slate-900 hover:bg-slate-100 transition-colors"
        data-testid={`psp-actions-trigger-${proposalId}`}
        aria-label="Acciones"
      >
        <MoreHorizontal className="w-4 h-4" />
      </button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" className="w-56" onClick={(e) => e.stopPropagation()}>
      {actions.map(({ key, label, icon: Icon, onClick, danger, separator }, i) => (
        <Fragment key={key}>
          {separator && i > 0 && <DropdownMenuSeparator />}
          <DropdownMenuItem
            onSelect={onClick}
            className={`cursor-pointer text-sm ${danger ? 'text-red-600 focus:text-red-700 focus:bg-red-50' : ''}`}
            data-testid={`psp-action-${key}-${proposalId}`}
          >
            <Icon className="w-4 h-4 mr-2" />
            {label}
          </DropdownMenuItem>
        </Fragment>
      ))}
    </DropdownMenuContent>
  </DropdownMenu>
);
